import exerciseConstants from './domains/Exercise/constants';
import exerciseCreateConstants from './domains/ExerciseCreate/constants';
import exerciseRunConstants from './domains/ExerciseRun/constants';
import exercisesConstants from './domains/Exercises/constants';
import exerciseWaitingRoomConstants from './domains/ExerciseWaitingRoom/constants';
import loginConstants from './domains/Login/constants';
import scenarioConstants from './domains/Scenario/constants';
import scenariosConstants from './domains/Scenarios/constants';
import socketConstants from './domains/Socket/constants';
import userConstants from './domains/User/constants';
import usersConstants from './domains/Users/constants';
import companiesConstants from './domains/Companies/constants';
import companyConstants from './domains/Company/constants';
import blacklistConstants from './domains/BlackList/constants';
import validateTokenConstants from './domains/ValidateToken/constants';
import loggerConstants from './domains/Logger/constants';
import categoryConstants from './domains/Category/constants';

const constants = {
  ...exerciseConstants,
  ...exerciseCreateConstants,
  ...exerciseRunConstants,
  ...exercisesConstants,
  ...exerciseWaitingRoomConstants,
  ...loginConstants,
  ...scenarioConstants,
  ...scenariosConstants,
  ...socketConstants,
  ...userConstants,
  ...usersConstants,
  ...companiesConstants,
  ...companyConstants,
  ...blacklistConstants,
  ...validateTokenConstants,
  ...loggerConstants,
  ...categoryConstants,
  TEXT_MESSAGE: 'TEXT_MESSAGE',
  AUDIO_MESSAGE: 'AUDIO_MESSAGE',
  AUDIO_MESSAGE_STATUS: 'AUDIO_MESSAGE_STATUS',
  BAD_MESSAGE: 'BAD_MESSAGE',
};

export default constants;
